import Box from '@material-ui/core/Box';
import DialogActions from '@material-ui/core/DialogActions';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import WarningIcon from '@material-ui/icons/Warning';
import tokens from 'tokens';
import { Button, Dialog } from '@attain-sre/attain-design-system';
import {
  TIMEFRAME_WARNING_ACCEPT_BUTTON,
  TIMEFRAME_WARNING_CANCEL_BUTTON,
  TIMEFRAME_WARNING_MESSAGE,
  TIMEFRAME_WARNING_MODAL_HEADER,
} from '../../../../content';

interface TimeframeWarningModalProps {
  open: boolean;
  onCancel: () => void;
  onAccept: () => void;
  header?: string;
  message?: string;
  instruction?: React.ReactNode;
  cancelButtonLabel?: string;
  acceptButtonLabel?: string;
}

const TimeframeWarningModal = ({
  open,
  onCancel,
  onAccept,
  header = TIMEFRAME_WARNING_MODAL_HEADER,
  message = TIMEFRAME_WARNING_MESSAGE,
  instruction,
  cancelButtonLabel = TIMEFRAME_WARNING_CANCEL_BUTTON,
  acceptButtonLabel = TIMEFRAME_WARNING_ACCEPT_BUTTON,
}: TimeframeWarningModalProps) => {
  // Determine what instruction to show:
  // - If instruction is undefined (not passed), show default
  // - If instruction is null (explicitly passed), show nothing
  // - If instruction is a React node, show that
  const shouldShowInstruction = instruction !== null;
  const displayInstruction = instruction;

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      headerID="timeframeWarningHeader"
      header={
        <Box display="flex" alignItems="center">
          <WarningIcon
            style={{
              color: tokens.colorIconWarning,
              fontSize: 24,
              marginRight: 8,
            }}
          />
          <Typography variant="h6">{header}</Typography>
        </Box>
      }
      bodyID="timeframeWarningBody"
      body={
        <Box p={1} style={{ backgroundColor: '#fff5ba' }}>
          <Typography
            variant="body1"
            style={{
              fontFamily: 'Calibre-Semibold,sans-serif',
              fontSize: 18,
              fontWeight: 500,
            }}
          >
            {message}
          </Typography>
          {shouldShowInstruction && (
            <Typography
              variant="body2"
              style={{
                marginTop: 16,
                fontFamily: 'Calibre-Regular,sans-serif',
                fontSize: 16,
              }}
            >
              {displayInstruction}
            </Typography>
          )}
        </Box>
      }
      footer={
        <DialogActions style={{ padding: '8px 16px' }}>
          <Button
            onClick={onCancel}
            color="primary"
            variant="contained"
            style={{ marginRight: 8 }}
          >
            {cancelButtonLabel}
          </Button>
          <Button onClick={onAccept} variant="outlined" color="primary">
            {acceptButtonLabel}
          </Button>
        </DialogActions>
      }
    />
  );
};

export default TimeframeWarningModal;
